import React from 'react';
import { FadeIn } from './FadeIn';
import { CheckCircle2 } from 'lucide-react';
import { motion } from 'framer-motion';
export function ProductReveal() {
  const features = ['Tus pesos rinden desde el primer día sin mover un dedo', 'Estrategia de supermercado que reduce tu ticket entre 25% y 40%', 'Primer resguardo en dólares desde el día 4, con lo que tenés hoy', 'Plan de liberación de deudas con el orden exacto para pagar menos intereses', 'Protocolo de ingresos extra que genera flujo en las primeras 72 horas', 'Sistema mental para no derrumbarse financieramente en el peor momento', 'Todo en un sistema de 30 minutos mensuales de mantenimiento'];
  return <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto text-center relative" data-id="element-332">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-[#22c55e]/10 blur-[100px] rounded-full pointer-events-none" data-id="element-333"></div>

      <FadeIn data-id="element-334">
        <motion.div animate={{
        y: [0, -10, 0]
      }} transition={{
        duration: 4,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="inline-block mb-3 md:mb-8 relative" data-id="element-335">
          <div className="absolute inset-0 bg-[#C9A84C]/20 blur-2xl rounded-full" data-id="element-336"></div>
          <span className="text-5xl md:text-8xl relative z-10 drop-shadow-[0_0_30px_rgba(201,168,76,0.5)]" data-id="element-337">
            🏆
          </span>
        </motion.div>

        <h2 className="text-3xl md:text-7xl font-black mb-3 md:mb-8 text-transparent bg-clip-text bg-gradient-to-b from-[#16a34a] via-[#22c55e] to-[#4ade80] tracking-tight drop-shadow-sm" data-id="element-338">
          SISTEMA ESCAPISTA PRO™
        </h2>

        <p className="text-base md:text-4xl font-bold text-[#0f172a] mb-6 md:mb-14 max-w-3xl mx-auto leading-tight px-2" data-id="element-339">
          6 Tomos + 6 Bonos · El sistema completo de supervivencia y fuga
          financiera para el argentino que decide dejar de improvisar.
        </p>
      </FadeIn>

      <FadeIn delay={0.2} data-id="element-340">
        <div className="bg-white border border-[#e2e8f0] rounded-2xl md:rounded-3xl p-5 md:p-12 max-w-3xl mx-auto text-left shadow-[0_20px_40px_rgba(34,197,94,0.1)] relative overflow-hidden" data-id="element-341">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#16a34a] via-[#22c55e] to-[#16a34a]" data-id="element-342"></div>

          <ul className="space-y-3 md:space-y-6 relative z-10" data-id="element-343">
            {features.map((feature, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            delay: index * 0.1
          }} viewport={{
            once: true
          }} className="flex items-center gap-3 md:gap-4" data-id="element-344">
                <div className="bg-[#22c55e]/10 p-1.5 md:p-2 rounded-full border border-[#22c55e]/20 shrink-0" data-id="element-345">
                  <CheckCircle2 className="text-[#22c55e] w-5 h-5 md:w-7 md:h-7" strokeWidth={2.5} data-id="element-346" />
                </div>
                <span className="text-sm md:text-2xl text-[#0f172a] font-bold" data-id="element-347">
                  {feature}
                </span>
              </motion.li>)}
          </ul>
        </div>
      </FadeIn>
    </section>;
}